var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { T } from 'helpers/i18n';
import { toMoney, toDateTime } from 'helpers/Format';
import Report from '../components/Report';
var CashDesks = /** @class */ (function (_super) {
    __extends(CashDesks, _super);
    function CashDesks() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CashDesks.prototype.componentDidMount = function () {
        this.props.store.reports.readCashDesk();
    };
    CashDesks.prototype.render = function () {
        var reports = this.props.store.reports;
        var headers = ['state', 'date', 'cashAmount', 'cardAmount'];
        var items = reports.cashDesks;
        return (React.createElement(Report, { header: headers, items: items, loading: !reports.cashDesksLoaded, keyExtractor: function (cashDesk) { return String(cashDesk.id); }, format: function (cashDesks) {
                return cashDesks.map(function (cashDesk) { return (__assign(__assign({}, cashDesk), { state: T(cashDesk.state), date: toDateTime(cashDesk.date), cashAmount: toMoney(cashDesk.cashAmount), cardAmount: toMoney(cashDesk.cardAmount) })); });
            } }));
    };
    CashDesks = __decorate([
        inject('store'),
        observer
    ], CashDesks);
    return CashDesks;
}(Component));
export default CashDesks;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/containers/CashDesk.tsx
// module id = 1139
// module chunks = 0